import React, { Component } from 'react';

//All of our API calls
import * as Actions from '../actions/action';

//Stores all of our API responses
import Store from '../stores/store';

//These are all our styles (font-awesome + our global css)
import '../styles/fonts/FontAwesome6/css/all.css';
import '../styles/global.css';

class FileUpload extends Component {


    constructor(props) {
        super(props);
        Actions.getAccessGroups();
        this.state = {
            file: null,
            fileName: "",
            fileType: "",
            title: "",
            desc: "",
            createResource: true,
            accessGroupSelection: "",
            selectedAccessGroups: [],
            allAccessGroups: [],
            uploadInProgress: false,
            processingDroppedFile: false,
        };

    }

    componentDidMount() {
        Store.on("Response_AccessGroupList_Updated", this._updateState.bind(this));
        Store.on("Response_File_Uploaded", this._fileUploaded.bind(this));
        Store.on("Response_Resource_SingleResource_Updated", this.updateSingleResource.bind(this));
        window.addEventListener('drop', this.handleDrop)
    }

    componentWillUnmount() {
    }

    handleDrop = (e) => {
        this.setState({ processingDroppedFile: true });
        this.setState({ drag: false });
        var myState = this;

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            let items = e.dataTransfer.files;

            for (let i = 0; i < items.length; i++) {
                const file = items[i];

                if (this.isExecutableFile(file)) {
                    // Executable file type is denied
                    alert('Executable files are not allowed.');
                    continue;
                }

                let reader = new FileReader();
                reader.fileName = file.name;

                reader.onload = function (e) {
                    var filename = e.target.fileName;
                    var parts = filename.split('.');
                    var nameWithoutExtension = parts.slice(0, -1).join('.');
                    myState.setState({
                        file: file,
                        title: nameWithoutExtension,
                        fileName: file.name,
                        fileType: file.type,
                    });
                };

                reader.readAsDataURL(file);
            }
        }

        e.dataTransfer.clearData();
        this.dragCounter = 0;
        this.setState({ processingDroppedFile: false });
    };

    isExecutableFile = (file) => {
        const blockedExtensions = ['exe', 'bat', 'cmd']; // Add more executable file extensions if needed
        const fileExtension = file.name.split('.').pop().toLowerCase();
        return blockedExtensions.includes(fileExtension);
    };


    _setFile = (newFile) => {

        var filename = newFile.name;
        var parts = filename.split('.');
        var nameWithoutExtension = parts.slice(0, -1).join('.');
        var mimeType = newFile.type; // Get the MIME type of the file

        this.setState({ file: newFile, title: nameWithoutExtension, fileName: newFile.name, fileType: newFile.type });
    }

    _updateState = () => {
        this.setState({ allAccessGroups: Store.getAccessGroups() });
    }

    _fileUploaded = () => {

        var resourceCreated = false;

        resourceCreated = this.state.createResource;

        this.setState({
            file: null,
            title: "",
            fileName: "",
            fileType: "",
            desc: "",
            createResource: this.state.createResource,
            accessGroupSelection: "",
            selectedAccessGroups: this.state.selectedAccessGroups,
            uploadInProgress: false
        });

        if (resourceCreated) {

            var resourceSingleResourceResponse = Store.getActionGroupFileUploadedInfo()
            Actions.getSingleResource(resourceSingleResourceResponse['externalId']);

        }
    }


    updateSingleResource = () => {
        Actions.getNewestReportsInfo();
    }

    _handleAccessGroupChange = (event) => {
        this.setState({ accessGroupSelection: event.target.value });
    }

    _handleTitleChange = (event) => {
        this.setState({ title: event.target.value });
    }

    _handleDescChange = (event) => {
        this.setState({ desc: event.target.value });
    }

    _handleCreateResourceChange = (event) => {
        this.setState({ createResource: event.target.checked });
    };


    _handleAdd(accessGroupId) {
        let item = this.state.allAccessGroups.find(i => i.accessGroupId === accessGroupId);

        let newList = [...this.state.selectedAccessGroups];
        newList.push(item);
        this.setState({ selectedAccessGroups: newList });
    }

    _handleFileRemove() {
        this.setState({
            file: null,
            title: "",
            fileName: "", fileType: "" });
    }

    _handleDelete(accessGroupId) {
        var updatedItems = this.state.selectedAccessGroups.filter(i => i.accessGroupId !== accessGroupId);
        this.setState({ selectedAccessGroups: updatedItems });
    }

    async _handleUpload() {
        let groups = this.state.selectedAccessGroups.map(a => a.accessGroupId);

        const formData = new FormData();
        formData.append("title", this.state.title);
        formData.append("fileName", this.state.fileName);
        formData.append("fileType", this.state.fileType);
        formData.append("file", this.state.file);
        formData.append("desc", this.state.desc);
        formData.append("createResource", this.state.createResource);
        formData.append("groups", groups);

        this.setState({
            uploadInProgress: true
        });


        Actions.uploadActionGroupFormData(formData);
    }

    async _handleNoUpload() {
        alert("Please fill out all of the required fields.")
    }

    render() {
        var fileUpload = [];
        var accessGroupList = [];
        var uploadButton = [];
        var accessGroupGranted = false;
        var fileUploadForm = [];
        Object.values(this.state.allAccessGroups).forEach(accessGroup => {

            accessGroupGranted = false;

            Object.values(this.state.selectedAccessGroups).forEach(selectedAccessGroup => {
                if (selectedAccessGroup.accessGroupId == accessGroup.accessGroupId) {
                    accessGroupGranted = true;
                }
            });

            if (accessGroupGranted) {
                accessGroupList.push(<div className="accessGroupCheckboxContainer" onClick={this._handleDelete.bind(this, accessGroup.accessGroupId)}><span className="fa-light fa-square-check"></span> {accessGroup.accessGroupName}</div>);
            }
            else {
                accessGroupList.push(<div className="accessGroupCheckboxContainer" onClick={this._handleAdd.bind(this, accessGroup.accessGroupId)}><span className="fa-light fa-square"></span> {accessGroup.accessGroupName}</div>);

            }
        });
        if ((this.state.title).length < 1 || Object.keys(this.state.selectedAccessGroups).length < 1 || this.state.file == null) {
            uploadButton.push(
                <button className=" singleButton accessGroups_NoUpload" onClick={this._handleNoUpload.bind(this)}>
                    <table>
                        <tbody>
                            <tr>
                                <td><span className="singleResultIcon fal fa-cloud-upload"></span></td>
                                <td><span className="footerText"><div className="topText">Create</div><div className="bottomText">Asset</div></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </button>
            );
        }
        else {
            uploadButton.push(
                <button className="singleResultButton_Create singleButton accessGroups_Upload" onClick={this._handleUpload.bind(this)}>
                    <table>
                        <tbody>
                            <tr>
                                <td><span className="singleResultIcon fal fa-cloud-upload"></span></td>
                                <td><span className="footerText"><div className="topText">Create</div><div className="bottomText">Asset</div></span></td>
                            </tr>
                        </tbody>
                    </table>
                </button>
            );
        }
        if (this.state.file == null) {
            fileUploadForm.push(
                <div>
                    <input className="hidden" type="file" name="accessGroupFile" id="accessGroupFile" onChange={(e) => this._setFile(e.target.files[0])} />
                    <label htmlFor="accessGroupFile" className="accessGroupFile_Label"><span className="fa-light fa-file-import"></span>Select file</label>
                </div>
            );
        }
        else {
            fileUploadForm.push(
                <div>
                    <span onClick={this._handleFileRemove.bind(this)} className="accessGroupFile_Label_Remove" title="Remove File" alt="Remove File"><span className="accessGroupFile_Remove fa-light fa-times"></span>{this.state.file.name}</span>
                </div>
            );
        }
        if (this.state.uploadInProgress) {
            fileUpload.push(

                <div>
                    <table className="employeeList_Header">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="fileUpload_Label_Container">
                                        <div className="fileUpload_LabelHeader"><i className="employeeList_icon fal fa-cloud-arrow-up"></i> Uploading</div>
                                        <div className="fileUpload_UploadingContainer">
                                            <i className="logoHome fas fa-circle-notch fa-spin"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        }
        else if (this.state.processingDroppedFile)
        {

            fileUpload.push(

                <div>
                    <table className="employeeList_Header">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="fileUpload_Label_Container">
                                        <div className="fileUpload_LabelHeader"><i className="employeeList_icon fal fa-cloud-arrow-up"></i> Processing</div>
                                        <div className="fileUpload_UploadingContainer">
                                            <i className="logoHome fas fa-circle-notch fa-spin"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        }
        else {

            fileUpload.push(
                <div>
                    <table className="employeeList_Header">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="fileUpload_Label_Container">
                                        <div className="fileUpload_LabelHeader"><i className="employeeList_icon fal fa-cloud-arrow-up"></i> File Upload</div>
                                        <table className="fileUpload_FileTable">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        File <span className="accessGroupsRequired" title="Required" alt="Required">*</span>
                                                    </td>
                                                    <td>
                                                        {fileUploadForm}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Title <span className="accessGroupsRequired" title="Required" alt="Required">*</span>
                                                    </td>
                                                    <td>
                                                        <input className="accessGroupTitle" type="text" value={this.state.title} onChange={this._handleTitleChange} placeholder="File Title" /> <br />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="descriptionUploadLabel">
                                                        Description
                                                    </td>
                                                    <td>
                                                        <textarea className="accessGroupDesc" value={this.state.desc} onChange={this._handleDescChange} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="descriptionUploadLabel">
                                                        Create Resource
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            className="accessGroupCreateResource"
                                                            checked={this.state.createResource}
                                                            onChange={this._handleCreateResourceChange} />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="employeeList_Header">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="fileUpload_Label_Container">
                                        <div className="fileUpload_LabelHeader"><i className="employeeList_icon fal fa-memo-pad"></i> Access Groups <span className="accessGroupsRequired" title="Required" alt="Required">*</span><span className="accessGroups_NumSelectedGroups_Container">(<span className="accessGroups_NumSelectedGroups">{Object.keys(this.state.selectedAccessGroups).length}</span>)</span></div>
                                        <div className="dynamicAccessGroupList">{accessGroupList}</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="accessGroup_uploadButtonContainer">
                        {uploadButton}
                    </div>
                </div>
            );
        }
        return (
            <div>{fileUpload}</div>
        )
    }
}

export default FileUpload